module.exports = __webpack_public_path__ + "static/images/fill-medium.fb5abb22b5b1673a0ac7abc7dcbe539c.svg";